import React from 'react';

interface WebpImageProps {
  src: string;
  alt: string;
  className?: string;
  webpSrc?: string; // 明示的にWebPのパスを指定する場合
  style?: React.CSSProperties;
}

/**
 * WebP画像をサポートするコンポーネント
 * ブラウザがWebPをサポートしていれば表示し、そうでなければ元の画像を表示する
 */
export const WebpImage: React.FC<WebpImageProps> = ({ 
  src, 
  alt, 
  className, 
  webpSrc,
  style 
}) => {
  // 自動的にWebPのパスを生成（元のパスの拡張子をwebpに置き換え）
  const generateWebpPath = (originalPath: string): string => {
    return webpSrc || originalPath.replace(/\.(jpe?g|png)$/i, '.webp');
  };

  return (
    <picture>
      <source srcSet={generateWebpPath(src)} type="image/webp" />
      <img src={src} alt={alt} className={className} style={style} />
    </picture>
  );
};

export default WebpImage; 